import { render, staticRenderFns } from "./CriterionManagementPage.vue?vue&type=template&id=863dd45c&scoped=true"
import script from "./CriterionManagementPage.vue?vue&type=script&lang=js"
export * from "./CriterionManagementPage.vue?vue&type=script&lang=js"
import style0 from "./CriterionManagementPage.vue?vue&type=style&index=0&id=863dd45c&prod&lang=css"
import style1 from "./CriterionManagementPage.vue?vue&type=style&index=1&id=863dd45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863dd45c",
  null
  
)

export default component.exports